import { Skeleton } from 'primereact/skeleton';
import classes from './loadingSkeleton.module.scss';

const SalesPlanLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default SalesPlanLoadingSkeleton;
